import { createContext, useContext, useEffect, useState } from "react";
import api, { apiError } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("vis_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("vis_token");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("vis_token", data.token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      const retryAfter = parseInt(e.response?.headers?.["retry-after"] || "0", 10) || 0;
      return { ok: false, error: apiError(e.response?.data?.detail) || e.message, retryAfter };
    }
  };

  const logout = () => {
    localStorage.removeItem("vis_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
